import { Organisation } from '~organisations/domain';

import logo from './images/logo.svg';

const amplifonConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {},
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default amplifonConfig;
